import React from "react";
import { Toaster } from "react-hot-toast";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

const ToastComponent = (): React.ReactElement => {
  return (
    <Toaster
      // position="top-center"
      containerClassName=""
      containerStyle={{
         
         top: 200,
      }}
      toastOptions={{
        // Define default options
        className: "",
        duration: 5000,
        style: {
          background: "#363636",
          color: "#fff",
        },

        // Default options for specific types
        success: {
          duration: 3000,
          style: {
            background: "green",
            color: "#fff",
          },
          icon: <CheckCircleOutlineOutlinedIcon />,
        },

        error: {
          duration: 2000,
          style: {
            background: "red",
          },
          icon: <ErrorOutlineOutlinedIcon />,
        },
      }}
    />
  );
};

export default ToastComponent;
